import React from "react";
import SliderComp from "../../../components/SliderComp";
import classes from "./Section5.module.css";

const partners = [
  "/img/partners/1.png",
  "/img/partners/2.png",
  "/img/partners/3.png",
  "/img/partners/4.png",
  "/img/partners/5.png",
  "/img/partners/6.png",
  "/img/partners/7.png",
  "/img/partners/8.png",
  "/img/partners/9.png",
  "/img/partners/10.png",
  "/img/partners/11.png",
  "/img/partners/13.png",
  "/img/partners/14.png",
  "/img/partners/15.png",
  "/img/partners/16.png",
  "/img/partners/17.png",
  "/img/partners/18.png",
  "/img/partners/20.png",
  "/img/partners/21.png",
  "/img/partners/22.png",
  "/img/partners/23.png",
  "/img/partners/24.png",
  "/img/partners/25.png",
  "/img/partners/26.png",
  "/img/partners/27.png",
  "/img/partners/28.png",
  "/img/partners/29.png",
  "/img/partners/30.png",
  "/img/partners/31.png",
];

export default function Section5() {
  return (
    <div className={classes.section5Wrapper}>
      {/* <SliderComp slidesToShow={8} autoplay={true} arrows={false}>
        {partners.map((img, index) => (
          <div key={index} className={classes.partnerItem}>
            <img src={img} alt="partner logo" className={classes.partnerLogo} />
          </div>
        ))}
      </SliderComp> */}

      <SliderComp slidesToShow={6} autoplay={true}>
        {partners.map((img, index) => (
          <div key={index} className={classes.partnerItem}>
            <img src={img} alt="partner logo" className={classes.partnerLogo} />
          </div>
        ))}
      </SliderComp>
    </div>
  );
}
